/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';
import { createBrowserHistory } from "history";
const history = createBrowserHistory({forceRefresh:true});


const  GetPublishData =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        `${maverickPortalApiEndPoint.getPublishData.url}/${data.user_ID}/${data.project_ID}`,
        maverickPortalApiEndPoint.getPublishData.methodType,
      )
      .then(response => {      
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //   // history.push(`/project/${data.project_ID}/publish`);  

        //   //  AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        resolve({ res });
        //history.push(`/project/${data.project_ID}/publish`);  

      });
  });
};

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { GetPublishData };
